import { render, staticRenderFns } from "./debug-video.vue?vue&type=template&id=38528ecb&scoped=true&"
import script from "./debug-video.vue?vue&type=script&lang=ts&"
export * from "./debug-video.vue?vue&type=script&lang=ts&"
import style0 from "./debug-video.vue?vue&type=style&index=0&id=38528ecb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38528ecb",
  null
  
)

export default component.exports